import React from 'react';
import { Grid, Card, CardHeader, CardContent, CardsList } from 'ceci-ui';
import { PageContainer } from '../../components/Page';
import CollectionRuleDrawerButton from '../../components/CollectionRuleDrawerButton';
import IssueChargeDrawerButton from '../../components/IssueChargeDrawerButton';
import SummaryCard from '../Home/SummaryCard';

function HomePage() {
  return (
    <PageContainer>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <SummaryCard />
        </Grid>
        <Grid item xs={9}>
          <Grid container justify="space-between">
            <IssueChargeDrawerButton />
            <CollectionRuleDrawerButton />
          </Grid>
          <Grid container spacing={4} style={{ marginTop: 16 }}>
            <Grid item xs={3}>
              <Card variant="outlined">
                <CardHeader title="25" />
                <CardContent>features</CardContent>
              </Card>
            </Grid>
            <Grid item xs={3}>
              <Card variant="outlined">
                <CardHeader title="300" />
                <CardContent>cobradas</CardContent>
              </Card>
            </Grid>
            <Grid item xs={3}>
              <Card variant="outlined">
                <CardHeader title="R$ 1.200,00" />
                <CardContent>recebido</CardContent>
              </Card>
            </Grid>
            <Grid item xs={3}>
              <Card variant="outlined">
                <CardHeader title="R$ 4.000,00" />
                <CardContent>a receber</CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <CardsList title="Agendadas">
                <Card variant="outlined">
                  <p><strong>Joana Ferreira</strong></p>
                  <p>Vencimento<br />Valor<br />Pagamento</p>
                </Card>
                <Card variant="outlined">
                  <p><strong>Joana Ferreira</strong></p>
                  <p>Vencimento<br />Valor<br />Pagamento</p>
                </Card>
                <Card variant="outlined">
                  <p><strong>Joana Ferreira</strong></p>
                  <p>Vencimento<br />Valor<br />Pagamento</p>
                </Card>
              </CardsList>
            </Grid>
            <Grid item xs={3}>
              <CardsList title="Emitidas">
                <Card variant="outlined">
                  <p><strong>Joana Ferreira</strong></p>
                  <p>Vencimento<br />Valor<br />Pagamento</p>
                </Card>
                <Card variant="outlined">
                  <p><strong>Joana Ferreira</strong></p>
                  <p>Vencimento<br />Valor<br />Pagamento</p>
                </Card>
                <Card variant="outlined">
                  <p><strong>Joana Ferreira</strong></p>
                  <p>Vencimento<br />Valor<br />Pagamento</p>
                </Card>
              </CardsList>
            </Grid>
            <Grid item xs={3}>
              <CardsList title="Atrasadas">
                <Card variant="outlined">
                  <p><strong>Joana Ferreira</strong></p>
                  <p>Vencimento<br />Valor<br />Pagamento</p>
                </Card>
                <Card variant="outlined">
                  <p><strong>Joana Ferreira</strong></p>
                  <p>Vencimento<br />Valor<br />Pagamento</p>
                </Card>
                <Card variant="outlined">
                  <p><strong>Joana Ferreira</strong></p>
                  <p>Vencimento<br />Valor<br />Pagamento</p>
                </Card>
              </CardsList>
            </Grid>
            <Grid item xs={3}>
              <CardsList title="Pagas">
                <Card variant="outlined">
                  <p><strong>Joana Ferreira</strong></p>
                  <p>Vencimento<br />Valor<br />Pagamento</p>
                </Card>
                <Card variant="outlined">
                  <p><strong>Joana Ferreira</strong></p>
                  <p>Vencimento<br />Valor<br />Pagamento</p>
                </Card>
                <Card variant="outlined">
                  <p><strong>Joana Ferreira</strong></p>
                  <p>Vencimento<br />Valor<br />Pagamento</p>
                </Card>
              </CardsList>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default HomePage;
